import React from 'react';
import Select, { Option } from 'rc-select';

type SchoolOption = {
  schoolId: string;
  name: string;
};

type IdentityUnavailableStateProps = {
  schoolName?: string;
  availableSchools: SchoolOption[];
  currentSchoolId: string;
  onSchoolChange: (schoolId: string) => void;
};

export const IdentityUnavailableState: React.FC<IdentityUnavailableStateProps> = ({
  schoolName,
  availableSchools,
  currentSchoolId,
  onSchoolChange,
}) => {
  const otherSchools = availableSchools.filter((s) => s.schoolId !== currentSchoolId);

  return (
    <div className="w-[100vw] h-[100vh] flex flex-col justify-center items-center bg-[#2b2b2c] text-white px-6">
      <div className="max-w-md text-center space-y-4">
        <h1 className="text-xl font-semibold">无法进入该学校</h1>
        <p className="text-[#ccc] leading-relaxed">
          {schoolName ? (
            <>
              「{schoolName}」下没有您可访问的班级，无法加载教师端内容。
              <br />
              请选择其他学校，或联系管理员为您分配班级。
            </>
          ) : (
            <>当前学校下没有您可访问的班级，请选择其他学校或联系管理员。</>
          )}
        </p>
        {otherSchools.length > 0 && (
          <div className="flex flex-col items-center gap-2 pt-2">
            <span className="text-sm text-[#aaa]">切换学校</span>
            <Select
              className="min-w-[240px]"
              style={{ fontSize: '16px' }}
              placeholder="选择学校"
              dropdownMatchSelectWidth={240}
              dropdownClassName="z-[10000]"
              onChange={(schoolId) => onSchoolChange(String(schoolId))}
            >
              {otherSchools.map((s) => (
                <Option key={s.schoolId} value={s.schoolId}>
                  {s.name}
                </Option>
              ))}
            </Select>
          </div>
        )}
      </div>
    </div>
  );
};
